module.exports = __webpack_public_path__ + "static/media/snake.806eb774.png";